// extracted by mini-css-extract-plugin
export default {"p":"_53d5b20262 a8c9a5c637 _06e2ef812f","clr":"_96ef7885ab","dls":"_9675a6150b"};